import React from "react";
import { Capacitor } from "@capacitor/core";
import { AlertCircle, RefreshCw } from "lucide-react";
import { APP_VERSION } from "../version";

interface VersionBlockModalProps {
  message: string;
  onRetry?: () => void;
  isVersionDisabled?: boolean;
}

const APP_STORE_URL = "https://apps.apple.com/us/app/whos-in/id6755683735";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.activitylink.app";

const VersionBlockModal: React.FC<VersionBlockModalProps> = ({
  message,
  onRetry,
  isVersionDisabled,
}) => {
  const handleRefresh = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  // Detect platform for store links
  let storeUrl = "";
  let storeLabel = "";
  if (isVersionDisabled) {
    if (Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
      if (Capacitor.getPlatform() === "ios") {
        storeUrl = APP_STORE_URL;
        storeLabel = "Update from App Store";
      } else if (Capacitor.getPlatform() === "android") {
        storeUrl = PLAY_STORE_URL;
        storeLabel = "Update from Play Store";
      }
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[200] p-4">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-2xl">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-900 text-center mb-3">
          Notification
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-6 leading-relaxed">
          {message}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          {isVersionDisabled &&
            (storeUrl ? (
              <a
                href={storeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-gray-100 text-gray-800 font-semibold py-3 px-6 rounded-full hover:bg-gray-200 transition-colors text-center"
              >
                {storeLabel}
              </a>
            ) : (
              <>
                <a
                  href={APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gray-100 text-gray-800 font-semibold py-3 px-6 rounded-full hover:bg-gray-200 transition-colors text-center"
                >
                  Update from App Store
                </a>
                <a
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gray-100 text-gray-800 font-semibold py-3 px-6 rounded-full hover:bg-gray-200 transition-colors text-center"
                >
                  Update from Play Store
                </a>
              </>
            ))}
        </div>

        {/* Version Info */}
        <p className="text-xs text-gray-400 text-center mt-4">
          Current version: v{APP_VERSION}
        </p>
      </div>
    </div>
  );
};

export default VersionBlockModal;
